// @flow
import styled from "styled-components"
import { mq, mqMax } from "common/mediaQuery"
import { Offset } from "componentsStyled/Layout/Offset"

export const StyledOffset = styled(Offset)`
  max-width: 66rem;

  ${mqMax.tabletWide} {
    width: 100%;
    max-width: none;
    padding: 1rem;
  }
`

export const PlanLinkWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  background-color: #fff;
  width: 100%;
  margin-top: 1.6rem;
  border: 0.2rem solid ${(props) => props.theme.color.primaryAccent};
  border-radius: 0.4rem;
  padding: 0.5rem;

  ${mq.tabletWide} {
    border-radius: 2.1rem;
  }

  ${mqMax.tabletWide} {
    flex-direction: column;
  }

  ${mqMax.phone} {
    margin-bottom: 1.2rem;
  }

  &:hover {
    cursor: pointer;
  }
`;

export const IconTile = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1.7rem 2.1rem;

  ${mq.tabletWide} {
    padding: 0.6rem 1.6rem 0.6rem 0.6rem;
  }

  ${mqMax.phone} {
    padding: 0.6rem 1.6rem 0.6rem 0.6rem;
  }
`

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  ${mqMax.phone} {
    width: 60%;
    padding: 1rem;
  }

  ${mqMax.tabletWide} {
    width: 100%;
    text-align: center;
  }
`

export const ArrowWrap = styled.div`
  display: flex;
  width: 3rem;
  margin: 0 0.5rem;
`

export const Arrow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${(props) => props.theme.color.primaryAccent};
  color: white;
  border-radius: 2rem;
  width: 2.8rem;
  height: 2.8rem;

  ${mqMax.phone} {
    right: 1rem;
  }
`;

export const Section = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  ${mqMax.tabletWide} {
    flex-direction: row;
  }
`



// WEBPACK FOOTER //
// ./src/components/PlanBanner/styled.js